//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/wecloud/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/wecloud/partners' // @/configurations/content/vtb/partners-dark для темной темы

export default {
  pageTitle: 'ИТ-фестиваль «Под открытым небом | | кодом»',
  logo: {
    image: require('@/assets/logo/T1 oblako white.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'T1 logo'
  },
 // pageBackgroundImage: require('@/assets/background/landing-background-3.jpg'),
//  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'ИТ-фестиваль «Под открытым небом | | кодом»',
  description: [
    '24 июля Т1 Облако приглашает всех, кто умеет отличить SaaS от IaaS, Kubernetes от Docker, DevOps от сисадмина и не путает SQL с NoSQL, GitLab c GitHub, на ИТ-фестиваль. Хороший повод вырваться из офиса и побеседовать о проектировании облаков, управлении базами данных под открытым небом, где даже критические баги кажутся не такими страшными.',
    '<b>Что будем делать?</b>',
    '<ul><li>Открыто говорить о том, что обычно обсуждают в кулуарах.</li><li>Делиться успешными кейсами по интеграции сервисов.</li><li>Разбирать нетривиальные отраслевые ситуации.</li><li>Наслаждаться свежим воздухом и июльским солнцем.</li></ul>',
    '<b>Для кого?</b>',
    'Для широкого круга ИТ-специалистов и сочувствующих: гуру инфраструктурных и сетевых решений, хранителей бэкапов, DevOps-ниндзя, архитекторов баз данных и руководителей команд, а также frontend- и backend-разработчиков, специалистов поддержки, системных аналитиков, экспертов Database security и всех, кто хочет участвовать в развитии сообщества дата-инженеров и архитекторов инфраструктуры. '
  ],
  date: '24 июля',
  time: '10:00–23:00'
  },
  activities: [
    {
      tabName: 'залы', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'uGubXTJE',
          id: 2817,
          hallName: 'Первый зал' // название зала
           },
           {
             hash: 'EwoFbrDs',
             id: 3026,
             hallName: 'Второй зал'
           },
           {
          hash: 'yOyYfnAo',
          id: 3027,
          hallName: 'Третий зал'
        }
      ]
    }
    // {
    //   tabName: '16.06.3023',
    //   items: [
    //     {
    //       hash: 'MAclQpGI',
    //       id: 1357,
    //       hallName: 'Третий зал'
    //     }
    //   ]
    // }
  ],
  player: {
    title: 'Регистрация' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Программа' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Где встречаемся?', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/map1.png'), // путь до изображения для блока с картинкой
    items: [
      '<b>Присоединяйтесь к нам:</b>',
      '<ul><li>Офлайн – для тех, кто хочет пообщаться вживую.</li><li>Онлайн, если вам комфортнее в домашних тапочках.</li></ul>',
      'Оставляйте заявку на участие в разделе «Регистрация» и дождитесь письма с подтверждением участия.',
      '<b>Цена участия:</b> бесплатно, как и главные вещи в этой жизни.',
      '<b>Приятные бонусы, для тех, кто придет офлайн:</b>',
      '<ul><li>Освежающие напитки,</li><li>Фуд-станции с анимацией,</li><li>Развлекательная программа, потому что все мы иногда хотим отдохнуть от работы.</li></ul>'
    ]
  },
  info: {
    title: 'Где встречаемся?', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      '<b>Присоединяйтесь к нам:</b>',
      '<ul><li>Офлайн – для тех, кто хочет пообщаться вживую.</li><a href="https://yandex.ru/maps/-/CDC~fI~Q" target="_blank">LOFT#4, Москва, 2-й Кожуховский пр., д. 29, корп. 6</a><li>Онлайн, если вам комфортнее в домашних тапочках.</li></ul>',
      'Оставляйте заявку на участие в разделе «Регистрация» и дождитесь письма с подтверждением участия.',
      '<b>Цена участия:</b> бесплатно, как и главные вещи в этой жизни.',
      '<b>Приятные бонусы для тех, кто придет офлайн:</b>',
      '<ul><li>Освежающие напитки,</li><li>Фуд-станции с анимацией,</li><li>Развлекательная программа, потому что все мы иногда хотим отдохнуть от работы.</li></ul>',
      '<b>Организатор</b>',
      'Т1 Облако – российский облачный провайдер, входит в многопрофильный холдинг T1.',
      'Мы помогаем компаниям разных отраслей и масштаба в оптимизации ИТ-инфраструктуры, обеспечении непрерывности бизнеса и ускорении процессов. Предоставляем комплексные решения с использованием публичных, частных и гибридных облаков. Нашим клиентам доступен широкий портфель облачных сервисов по моделям IaaS, PaaS, SaaS, а также стек импортонезависимых решений на базе отечественных технологий для выполнения широкого спектра задач любой сложности.',
     '<p><hr / color="#ffffff"><br>',
      '<a href="https://vk.com/t1_cloud"><img style="margin-right:50px"width="60" height="70" src="assets/image-block/вк-_2_.png"</a><a href="https://t.me/+6LbPZnumFOA0MzMy"><img style="margin-right:50px"width="60" height="70" src="assets/image-block/тг-_2_.png"</a><a href="https://t1-cloud.ru/?utm_source=wecloudevents&utm_medium=landing_page&utm_campaign=it_festival_24.07.24&utm_content=own"><img style="margin-right:50px"width="60" height="70" src="assets/image-block/замок-_2_.png"</a> '
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Партнеры' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Т1 Облако,'
    // phone: '+7 926 260 53 22'
  }
}
